module.exports = __webpack_public_path__ + "6cf24c016b2871fdde65bf37e05a83b9.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=700!./images/Foto_Manja_Herrmann-8484.jpg
// module id = 602
// module chunks = 0